/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum WeightingPolicyStrategy {
    WEIGHTED_TO_ONE = 'weightedToOne',
    CUT_MAPPING_WEIGHTED = 'cutMappingWeighted',
    INCS_WEIGHTED = 'incsWeighted',
    ORGS_WEIGHTED = 'orgsWeighted',
}
